import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles.css';
import { useEffect } from 'react';
import { useDestination } from './routeur';
import { masquerVoile } from './voile';
import { Installer } from './pages/Installer';
import { Confidentialite } from './pages/Confidentialite';
import { Demo } from './pages/Demo';
import { Reinitialiser } from './pages/Reinitialiser';
import { App } from './app/App';
import { creerJournalErreurs } from './app/journal';

// Le journal des erreurs s'installe AVANT le premier rendu : un crash au demarrage
// est exactement ce qu'on veut voir. Sans session, il n'envoie rien.
creerJournalErreurs().installer();

function Racine() {
  const destination = useDestination();

  // Les pages publiques n'ont pas de session a verifier : le voile de lancement s'efface
  // des qu'elles sont montees. Pour l'application, c'est App qui le fait, une fois la
  // session verifiee — le voile couvre ainsi toute l'attente.
  useEffect(() => {
    if (destination !== 'app') masquerVoile();
  }, [destination]);

  switch (destination) {
    case 'app':
      return <App />;
    case 'confidentialite':
      return <Confidentialite />;
    case 'demo':
      return <Demo />;
    case 'reinitialiser':
      return <Reinitialiser />;
    default:
      return <Installer />;
  }
}

const point = document.getElementById('racine');
if (point === null) throw new Error("L'element racine est introuvable dans index.html");

createRoot(point).render(
  <StrictMode>
    <Racine />
  </StrictMode>,
);

// Service worker uniquement en production : en developpement il servirait des fichiers
// mis en cache a la place de ceux que Vite vient de recompiler, et on passerait des
// heures a debusquer une modification « qui ne s'applique pas ».
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // L'echec d'enregistrement ne doit pas empecher l'application de fonctionner :
      // on perd le hors-ligne et l'installation, pas l'usage.
    });
  });
}
